import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  getFrontendShareUrl(id: number | string, type: 'yachts' | 'merchandises'): string {
    const base = environment.apiUrl;

    const cleanBase = base.endsWith('/') ? base.slice(0, -1) : base;
    return `${cleanBase}/product/share/${id}?v=2`;
  }

  getShareImageUrl(id: number | string, photoId: number | string = 0): string {
    return `${environment.apiUrl.replace(/\/$/, '')}/Product/share-image/${id}?v=1-${photoId}`;
  }
}
